/**
 * Container measurement guard for the canvas viewport.
 *
 * A hidden parent (`display: none` during a step switch, or while the guided
 * entry replaces the editor surface) still fires ResizeObserver, but reports a
 * 0x0 rectangle. Writing that through would collapse the canvas viewport and
 * force a re-fit once the editor becomes visible again.
 */

export interface ContainerSize {
  width: number;
  height: number;
}

/**
 * Returns the size to apply for a freshly measured rectangle.
 *
 * A degenerate measurement (zero or negative in either axis) keeps the previous
 * size instead of collapsing it.
 */
export function resolveContainerSize(
  measured: ContainerSize,
  current: ContainerSize
): ContainerSize {
  if (measured.width > 0 && measured.height > 0) {
    return measured;
  }
  return current;
}
